import { useAppSelector } from '../hooks'

export const useCurrencySelector = () => useAppSelector((state) => state.currency)
